import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '@/layout'

const routes = [{
    path: '/',
    name: 'Login',
    component: () => import( /* webpackChunkName: "about" */ '../views/Login') // 登录
}, {
    path: '/',
    component: Layout, // 项目 二级路由
    hidden: true,
    children: [{
        path: '/site-map',
        name: 'SiteMap',
        title: '站点地图位置',
        component: () => import( /* webpackChunkName: "about" */ '../views/SiteMap') // 站点地图位置
    }, {
        path: '/real-data',
        name: 'RealData',
        title: '实时数据',
        component: () => import( /* webpackChunkName: "about" */ '../views/RealData') // 实时 数据
    }, {
        path: '/history-data',
        name: 'HistoryData',
        title: '历史数据',
        component: () => import( /* webpackChunkName: "about" */ '../views/HistoryData/history') // 历史 数据
    }, {
        path: '/alarm-data',
        name: 'AlarmData',
        title: '报警数据',
        component: () => import( /* webpackChunkName: "about" */ '../views/AlarmData') // 报警 数据
    }, {
        path: '/statistical-overview',
        name: 'StatisticalOverview',
        title: '流量统计总览',
        component: () => import( /* webpackChunkName: "about" */ '../views/StatisticalOverview') // 流量统计 总览
    }, {
        path: '/statistical-data',
        name: 'StatisticalData',
        title: '流量统计报表',
        component: () => import( /* webpackChunkName: "about" */ '../views/StatisticalData') // 流量统计 报表
    }, {
        path: '/device-control',
        name: 'DeviceControl',
        title: '设备控制',
        component: () => import( /* webpackChunkName: "about" */ '../views/DeviceControl') // 设备 控制
    }, {
        path: '/white-board',
        name: 'Whiteboard',
        title: '大屏白板',
        component: () => import( /* webpackChunkName: "about" */ '../views/Whiteboard') // 大屏 白板
    }, {
        path: '/no-permission',
        name: 'NoPermission',
        title: '大屏白板',
        component: () => import( /* webpackChunkName: "about" */ '../views/NoPermission') // 大屏 白板
    }, {
        path: '/param-group-statistical',
        name: 'ParamGroupStatistical',
        title: '站点分组统计',
        component: () => import( /* webpackChunkName: "about" */ '../views/ParamGroupStatistical') // 大屏 白板
    }]
}
// ,{
//     path: '/big-screen',
//     name: 'BigScreen',
//     component: () => import( /* webpackChunkName: "about" */ '../views/BigScreen') // 登录
// }
]

const router = new VueRouter({
    mode: 'history',
    // mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    let token = localStorage.getItem("gasHomeToken");
    if (token) {
        //已登录，路由权限判断
        const fullPath = to.fullPath.slice(1)
        const gasHomeMenuList = localStorage.getItem('gasHomeMenuList')
        if (gasHomeMenuList && (gasHomeMenuList == 'all' || gasHomeMenuList.includes(fullPath))) {
            let defaultPath = '/' + localStorage.getItem('gasHomeMenuList').split(',')[0];
            if (to.path == "/") {
                if (localStorage.getItem('gasHomeMenuList') == 'all') {
                    next({name: "SiteMap"});
                } else {
                    next({path: defaultPath});
                }
            } else {
                next();
            }
        } else {
            if (to.path === "/no-permission") {
                next();
            } else if (to.path == "/big-screen") {
                next();
            } else {
                next({name: "NoPermission"});
            }
        }
    } else {
        if (to.path == "/" || to.path == "/big-screen") {
            next();
        } else {
            next({path: "/"});
        }
    }
})

export default router